import VerticalProgressBar from "./VerticalProgressBar";

export default VerticalProgressBar;
